// extracted by mini-css-extract-plugin
export default {"container":"AboutPage_container__xt0cC","teamTitle":"AboutPage_teamTitle__eCgi0","memberLayout":"AboutPage_memberLayout__9DJi+"};